import { buildSearchReport } from "../kernel/search.js";
import { projectPositionSummary } from "../kernel/projectors.js";
import {
  commitLineSelect,
  loadPositionForCommand,
} from "../kernel/board-engine.js";
import type { ExecutionContext } from "../runtime/context.js";
import type {
  LineSelectRequest,
  LineShowRequest,
} from "../cli/protocol.js";

export async function handleLineSelect(
  context: ExecutionContext,
  request: LineSelectRequest,
) {
  const result = await commitLineSelect(context, request.s, {
    fromPositionRef: request.p,
    pathId: request.a,
  });
  return {
    board: result.board,
    parent: projectPositionSummary(result.parent),
    path: result.path,
    position: projectPositionSummary(result.position),
  };
}

export async function handleLineShow(
  context: ExecutionContext,
  request: LineShowRequest,
) {
  const { board, position } = await loadPositionForCommand(context, request.s, request.p);
  const report = buildSearchReport(board, position, 1);
  const selectedPathId = position.stateSnapshot.line.selectedPathId;
  return {
    line: {
      selectedPathId,
      selectedPath:
        selectedPathId === undefined
          ? undefined
          : position.stateSnapshot.atoms[selectedPathId],
    },
    position: projectPositionSummary(position),
    report,
  };
}
